import React from 'react';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import InfoIcon from 'assets/info.svg';

interface InfoTooltipProps {
  /** The tooltip content */
  title: React.ReactNode;
  /** Tooltip placement position */
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';

  /** Additional CSS classes for the wrapper span */
  className?: string;
  /** Additional CSS classes for the icon */
  iconClassName?: string;
}

/**
 * A reusable info tooltip component that displays an info icon with a tooltip on hover
 *
 * @example
 * ```tsx
 * <InfoTooltip title="This is helpful information" />
 *
 * <InfoTooltip
 *   title="Custom tooltip content"
 *   placement="top"
 *   className="ml-2"
 * />
 * ```
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  placement = 'top',
  className = '',
  iconClassName = ''
}) => {
  return (
    <Tooltip title={title} placement={placement} color="#232630">
      <span
        className={`inline-flex items-center cursor-help ${className}`}
        data-testid="info-tooltip"
      >
        <img
          src={InfoIcon}
          alt="info-icon"
          className={`w-4 h-4 ${iconClassName}`}
        />
      </span>
    </Tooltip>
  );
};

export default InfoTooltip;
